import React from "react";
import IconComponent from "./LogoIcon";

// LPChatLogo: Componente que renderiza el logo de LPChat.

const LPChatLogo = ({ theme }) => {
    return (
        <div className="content-navigation__logo">
            <IconComponent />
            <span className="logo-title-LP">LP</span>
            <span className={`logo-title-CHAT ${theme}`}>Chat</span>
        </div>

    )
};

export default LPChatLogo;